import { EditOutlined, ProfileOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import {
  productStatusColors,
  productStatusLabels,
} from 'apps/investcore/constants/fundProduct';
import UIIconTooltip from 'common/ui/UIIconTooltip';
import { Link } from 'react-router-dom';
import { currencyCell, dateTimeCell, linkCell } from 'utils/cell-formatter';
import { cloudflareCdn } from 'utils/image';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/admin/products/etfs' }),
  },
  {
    accessorKey: 'symbol',
    header: 'Code',
  },
  {
    accessorKey: 'logo',
    header: 'Logo',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const logoUrl = getValue();
      return logoUrl ? (
        <img
          src={cloudflareCdn(logoUrl, 100)}
          alt="Logo"
          className="w-16 rounded"
        />
      ) : (
        '-'
      );
    },
  },
  {
    accessorKey: 'name',
    header: 'Name',
  },
  {
    accessorKey: 'status',
    header: 'Status',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const status = getValue();
      return (
        <Tag color={productStatusColors[status]}>
          {productStatusLabels[status]}
        </Tag>
      );
    },
  },
  {
    accessorKey: 'price',
    header: 'Price',
    meta: { className: 'text-right' },
    cell: currencyCell,
  },
  {
    accessorKey: 'price_last_updated',
    header: 'Price last updated',
    meta: { className: 'text-right' },
    cell: dateTimeCell,
  },
  {
    accessorKey: 'id',
    header: 'Action',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const id = getValue();
      return (
        <div className="flex items-center justify-center gap-3">
          <Link to={`/admin/products/etfs/${id}/edit`}>
            <UIIconTooltip title="Edit Stock" Icon={EditOutlined} />
          </Link>
          <Link to={`/admin/products/etfs/${id}/edit-profile`}>
            <UIIconTooltip title="Edit ETF Profile" Icon={ProfileOutlined} />
          </Link>
        </div>
      );
    },
  },
];
